import type { Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import type { VelocityCalculationTask, VelocityCalculationTaskStatus } from '../../model/types';
import * as rest from '../../rest/velocity-data-fetch';
import type { GetVelocityCalculationTaskStatusResponse } from '../../rest/velocity-data-fetch/types.tsx';
import { getBoardId } from '../../state/selectors/base';
import type { MiddlewareAPI } from '../../state/types';

export const transformGetVelocityCalculationTaskStatusResponse = (
	response: GetVelocityCalculationTaskStatusResponse,
): VelocityCalculationTaskStatus => {
	const chartModel = response.chartModel;

	return {
		result: chartModel?.sprints.reverse().map((sprint) => {
			const statsData = chartModel.velocityStatEntries[String(sprint.id)];

			return {
				id: sprint.id,
				name: sprint.name,
				estimated: statsData.estimated.value,
				completed: statsData.completed.value,
			};
		}),
		isRunning: response.isRunning,
		progress: response.progress / 100,
		progressUpdate: response.lastMessage,
	};
};

export const startVelocityCalculationTask = (
	store: MiddlewareAPI,
): ObservableType<VelocityCalculationTask> => {
	const state = store.getState();
	const boardId = getBoardId(state);

	return rest.startVelocityCalculationTask(boardId);
};

export const getVelocityCalculationTaskStatus = (
	_: MiddlewareAPI,
	taskId: string,
): ObservableType<VelocityCalculationTaskStatus> =>
	rest
		.getVelocityCalculationTaskStatus(taskId)
		.map(transformGetVelocityCalculationTaskStatusResponse);
